export default __webpack_public_path__ + "static/media/(9).d2d940be.jpg";